import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import "../../styles/AuraSection.css";
import {
  sectionStagger,
  fadeUpItem,
  revealViewport,
} from "../animations/animationVariants";

const AuraSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/aura');
  };
  return (
    <section className="aura-section">
      <motion.span
        className="section-eyebrow"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        02 / Product
      </motion.span>
      <motion.h2
        className="title"
        variants={fadeUpItem}
        initial="hidden"
        whileInView="visible"
        viewport={revealViewport}
      >
        Aura<em className="title-dot">.</em>
      </motion.h2>

      <div className="content-wrapper">
        <div className="middle-line"></div>

        <motion.div
          className="left-content"
          variants={fadeUpItem}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <h3 className="left-title">
            <span className="highlight">Aura</span> — 시선을 사로잡는 경험, 성장을 이끄는 데이터
          </h3>
          <p>
            Aura는 오프라인 공간에 몰입형 AR을 더해 관람객의 발길을 멈추게 하고, 현장의 생생한 반응을 데이터로 분석해 다음 기획의
            확실한 해답을 제시하는 통합 클라우드 솔루션입니다.
          </p>
          <button type="button" className="learn-more-btn" onClick={handleClick}>
            Aura 더 알아보기<span className="btn-arrow" aria-hidden="true">→</span>
          </button>
        </motion.div>

        <motion.div
          className="right-content"
          variants={sectionStagger}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
        >
          <motion.div className="feature" variants={fadeUpItem}>
            <div className="feature-text">
              <h4>관람객의 참여를 이끄는 WebAR</h4>
              <p>
                평범한 오프라인 공간에 3D와 브랜드 스토리를 더해, 방문객의 호기심과 자발적인 참여를 극대화합니다.
              </p>
            </div>
            <img src='/image/icon-07.svg' alt="WebAR Icon" className="feature-icon2" />
          </motion.div>
          <motion.div className="feature" variants={fadeUpItem}>
            <div className="feature-text">
              <h4>장벽 없는 즉시 배포·운영</h4>
              <p>
                번거로운 앱 설치 없이, 자동 생성되는 링크와 QR코드만으로 완성된 콘텐츠를 현장에 즉각 연결합니다.
              </p>
            </div>
            <img src='/image/icon-02.svg' alt="통합 운영" className="feature-icon3" />
          </motion.div>
          <motion.div className="feature" variants={fadeUpItem}>
            <div className="feature-text">
              <h4>키리(KIRI)의 데이터 컨설팅</h4>
              <p>
                체류 시간, 상호작용 등 오프라인의 숨겨진 반응을 분석하여 다음 기획과 운영에 필요한 인사이트를 제공합니다.
              </p>
            </div>
            <img src='/image/icon-06.svg' alt="Data Icon" className="feature-icon" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AuraSection;
